<template>
    <v-ons-page>
        <ons-toolbar>
            <div class="left"><ons-back-button></ons-back-button></div>
            <div class="center">Collections</div>
        </ons-toolbar>
        <div class="qf-search-filter">
            <div class="center">
                <v-ons-search-input model-event="change" :placeholder="searchPlaceholder" v-model="searchString"></v-ons-search-input>
            </div>
            <div class="right">
                <v-ons-toolbar-button @click="showFilter = !showFilter" modifier="white-content" slot="right">
                    <v-ons-icon icon="md-filter-list"></v-ons-icon>
                </v-ons-toolbar-button>
            </div>
        </div>
        <div v-if="Object.keys(primaryFilters).length !== 0" class="qf-filter direct-filter">
            <v-ons-list class="qf-label-data" style="padding: 6px 0 8px; background: #303030">
                <v-ons-list-item :key="index" v-for="(oneFilter, key, index) in primaryFilters" class="qf-filter-control">
                    <div class="center">
                        <ons-input
                            :id="key"
                            readonly
                            :placeholder="key"
                            :value="curFilterValue(oneFilter.id)"
                            @click="openSingleFilter(key, oneFilter)"></ons-input>
                    </div>
                </v-ons-list-item>
            </v-ons-list>
        </div>
        <div v-show="showFilter" class="qf-filter" title="Filters">
            <v-ons-list class="qf-label-data" v-if="Object.keys(secondaryFilters).length !== 0" style="padding: 4px 0;">
                <v-ons-list-item
                    :key="index"
                    v-for="(oneFilter, key, index) in secondaryFilters" class="qf-filter-control">
                    <div class="left">{{key}}</div>
                    <div class="center">
                        <ons-input :id="key"
                                   readonly
                                   :value="curFilterValue(oneFilter.id)"
                                   @click="openSingleFilter(key, oneFilter)"></ons-input>
                    </div>
                </v-ons-list-item>

                <div v-if="false">
                    <v-ons-list-item :key="index" class="qf-filter-control"  v-for="(oneFilter, key, index) in filters">
                        <div class="left">{{key}}</div>
                        <div class="center">
                            <v-ons-select v-model="selectedFilters[oneFilter.id]" class="w100" readonly>
                                <option value="">Any</option>
                                <option :key="optnIndex" :value="viableOption.value" v-for="(viableOption,optnIndex) in oneFilter.results">
                                    {{viableOption.value}} ({{viableOption.count}})
                                </option>
                            </v-ons-select>
                        </div>
                    </v-ons-list-item>
                </div>

                <section style="margin: 16px">
                    <v-ons-button @click="applyFilters('apply')" style="width: 100%">
                        Apply Filters
                    </v-ons-button>

                    <v-ons-button @click="applyFilters('reset')" modifier="outline" v-show="false">
                        Reset Filters
                    </v-ons-button>
                </section>
            </v-ons-list>
            <div class="qf-no-filters" v-else>
                <p>This collection does not have any applicable filters.</p>
            </div>
        </div>
        <div class="qf-collection-header">
            <div v-if="filtersActive" class="qf-filters-notice">
                <v-ons-icon icon="fa-exclamation-triangle"></v-ons-icon> Filters are currently active! <span v-if="filteredResCount !== null">Found {{filteredResCount}} results.</span> <span class="qf-close-banner"><v-ons-icon icon="fa-times" @click="applyFilters('reset', true)"></v-ons-icon></span>
            </div>
            <v-ons-list-title>{{title}}</v-ons-list-title>
            <div v-if="description" v-html="description" class="qf-collection-header-content"></div>
            <p v-else class="qf-collection-header-content">
                <em>This collection does not have a specific description</em>
            </p>

        </div>
        <div v-if="renderBlock">
            <v-ons-card :key="index" @click="openSingleCollectionItem(colItem)" class="qf-collection-single-wrapp" v-for="(colItem, index) in listItems">
                <div class="title">
                    {{colItem.title}}
                </div>
                <img  :alt="colItem.title" :src="colItem.thumbnail" style="width: 100%" v-if="colItem.thumbnail">
                <img :alt="colItem.title" :src="defaultLogo" style="width: 100%" v-else />

                <div class="content" v-if="colItem.fields[0]">
                    {{colItem.fields[0].value[0]}}
                </div>
            </v-ons-card>
            <div v-if="remainingPages" @click="loadMoreItems" class="qf-centered qf-padding-tb">
                <v-ons-button>Load more items</v-ons-button>
            </div>
        </div>
        <qf-spinner :showing="loadingData" message="Updating items list..."></qf-spinner>
    </v-ons-page>
</template>

<script>
    import SingleCollectionItem from "./SingleCollectionItem";
    import SingleFilter from "./SingleFilter";
    import QfSpinner from "../shared/QfSpinner";
    import Api from "../../services/api";
    export default {
        name: "SingleCollection",
        components: {QfSpinner},
        data() {
            return {
                showFilter: false,
                items: [],
                description: '',
                searchString: '',
                prevResults: [],
                renderComponent: true,
                //selectedFilters: [],
                filtersActive: false,
                filteredResCount: null,
                loadingData: false,
                curResultPage: 1,
                items_count: 0
            };
        },
        computed: {
            primaryFilters() {
                let primaryFilters = {};
                let allFilters = this.filters;
                for (let key in this.filters) {
                    // skip loop if the property is from prototype
                    if (!Object.prototype.hasOwnProperty.call(allFilters, key)) continue;

                    let obj = this.filters[key];
                    if(obj.isPriority){
                        primaryFilters[key]=obj;
                    }
                }
                return primaryFilters;
            },
            secondaryFilters() {
                let secondaryFilters = {};
                let allFilters = this.filters;
                for (let key in this.filters) {
                    // skip loop if the property is from prototype
                    if (!Object.prototype.hasOwnProperty.call(allFilters, key)) continue;

                    let obj = this.filters[key];
                    if(!obj.isPriority){
                        secondaryFilters[key]=obj;
                    }
                }
                return secondaryFilters;
            },
            selectedFilters(){
                return this.$store.state.collections.selectedFilters;
            },
            defaultLogo(){
                return `https://`+process.env.VUE_APP_VARIANT+`.capecloud.ch/images/placeholder-logo.png`
            },
            listItems() {
                return this.items;
            },
            renderBlock(){
                return this.renderComponent;
            },
            searchPlaceholder() {
                if(this.alias){
                    return 'Search by '+this.alias;
                }else {
                    return 'Search by title';
                }
            },
            remainingPages(){
                let relevantCount = this.items_count;
                if(this.filtersActive) relevantCount = this.filteredResCount;
                let totalPages = Math.floor(relevantCount / 36) + 1;
                return  (totalPages - this.curResultPage);
            }
        },
        mounted() {
            this.$store.commit('collections/resetFilters');
        },
        methods: {
            curFilterValue(filterId){
                let curValue = '';
                if(this.selectedFilters){
                    let match = this.selectedFilters.find(oneFilter => oneFilter.id == filterId);
                    if(match){
                        curValue = match.filterVal;
                    }
                }
                return curValue;
            },
            loadMoreItems() {
                this.curResultPage += 1;
                this.fetchMoreItems()
            },
            openSingleCollectionItem(colItem) {
                let self = this;
                this.$store.commit('navigator/push', {
                    extends: SingleCollectionItem,
                    data() {
                        colItem.parentCollection = {
                            id: self.id,
                            title: self.title
                        };
                        return colItem;
                    }
                })
            },
            openSingleFilter(name, filterObj){
                //console.log("Filter obj", filterObj);
                this.$store.commit('navigator/push', {
                    extends: SingleFilter,
                    data() {
                        return {
                            title: name,
                            filter: filterObj
                        }
                    }
                })
            },
            composeFilterUri(){
                let baseRequestUri = '/collections/'+this.id+'/items?';
                let self = this;
                let comb = '';
                if(this.searchString){
                    baseRequestUri+='title='+this.searchString;
                    comb = '&';
                    self.filtersActive = true;
                }
                if(this.selectedFilters.length>0){
                    self.selectedFilters.forEach(function(filterRow){
                        if(filterRow.filterVal){
                            baseRequestUri+=comb+filterRow.id+'='+filterRow.filterVal;
                            if(!comb && comb !== '&'){
                                comb = '&';
                            }
                            self.filtersActive = true;
                        }
                    });
                }else if (this.selectedFilters.length === 0 && !this.searchString) {
					self.filtersActive = false;
                }
                baseRequestUri+='&page='+self.curResultPage;
                console.log("Resulting URL", baseRequestUri);
                return baseRequestUri;
            },
            applyFilters(mode, resetSearch = false) {
                let self = this;

                if(mode ==='reset'){
                    self.$store.commit('collections/resetFilters');
                    if(resetSearch) {
                        self.searchString = '';
                        self.filteredResCount = null;
                    }
                }
                if(mode !=='reset'){
                    self.showFilter = false;
                }
                this.fetchItems();
            },
            forceRerender() {
                // Remove my-component from the DOM
                let self = this;
                this.renderComponent = false;

                // If you like promises better you can
                // also use nextTick this way
                this.$nextTick().then(() => {
                    // Add the component back in
                    self.renderComponent = true;
                });
            },
            fetchItems() {
                let fullRequestUri = this.composeFilterUri();
                let self = this;
                self.loadingData = true;
                Api().get(fullRequestUri).then(response => {
                    console.log("Search result details: ", response.data);
                    self.items = response.data.results;
                    self.loadingData = false;
                    self.filteredResCount = response.data.count;
                    //self.forceRerender();
                }).catch(err => {
                    self.loadingData = false;
                    console.log(err);

                });
            },
            fetchMoreItems() {
                let fullRequestUri = this.composeFilterUri();
                let self = this;
                self.loadingData = true;
                Api().get(fullRequestUri).then(response => {
                    console.log("Additional result details: ", response.data);
                    let curList = JSON.parse(JSON.stringify(self.items));
                    curList = curList.concat(response.data.results);
                    self.items = [];
                    self.items = curList;
                    //self.items.splice();
                    self.loadingData = false;
                }).catch(err => {
                    self.loadingData = false;
                    console.log(err);

                });
            }
        },
        watch: {
            searchString(str) {
                this.curResultPage = 1;
                if(!str){
                    if(this.prevResults.length > 0 && !this.filtersActive){
                        this.items = this.prevResults;
                    }else if (this.filtersActive){
                        this.fetchItems();
                    }
                }else {
                    if(this.prevResults.length === 0){
                        this.prevResults = this.items;
                    }
                    this.fetchItems();
                }
            },
            selectedFilters:{
                immediate: true,
                deep: true,
                handler(newVal){
                    if(newVal){
                        //console.log("Updated filters: ", newVal);
                        this.applyFilters('normal', false);
                        this.curResultPage = 1;
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .qf-no-filters {
        padding: 40px 20px;
    }
    .qf-filters-notice {
        display: block;
        color: white;
        text-transform: uppercase;
        font-size:0.75em;
        padding: 5px 20px;
        box-sizing: border-box;
    }
    .qf-filter .content {
        background: #333333;
    }
    .content {
        overflow-y: auto;
        height: 100%;
    }

    .qf-collection-single-wrapp {
        padding: 10px 0;
    }

    .qf-collection-single-wrapp .title {
        margin: 0 0 10px;
        padding: 0 10px;
    }

    .qf-collection-single-wrapp img {
        margin-bottom: 10px;
    }

    .qf-collection-single-wrapp .content {
        padding: 0 10px;
    }
    .list-title{
        background: #2f2f2f;
        padding-bottom: 4px;
    }
    .qf-collection-header-content {
        font-size: 14px;
        margin: 0;
        padding: 0 16px 6px;
    }
    section{
        margin: 16px;
        display: flex;
        justify-content: space-between;
    }
    .qf-close-banner {
        float: right;
    }
    .qf-centered {
        text-align: center;
        position: relative;
    }
    .qf-padding-tb {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .qf-filter.direct-filter .qf-label-data .center {
        padding-top: 8px;
    }
</style>
